import './button-style.scss'

import classNames from 'classnames'
import React from 'react'

const Button = ({ onPress, title, small }) => (
  <div
    className={classNames({
      'contianer-button': true,
      small,
    })}
    tabIndex={0}
    onKeyDown={onPress}
    onClick={onPress}
    role="button"
  >
    <p className="text-button">{title}</p>
  </div>
)

export default Button
